// Curated, grouped skills for the PDF resume ("Category: a, b, c" rows).
const resumeSkills = [
  {
    category: 'Mobile & Frontend',
    items: ['React Native', 'Expo', 'Expo Router', 'React', 'Next.js', 'React Native Web', 'TypeScript', 'JavaScript (ES6+)', 'HTML', 'Native Modules (Swift/Kotlin)']
  },
  {
    category: 'State Management',
    items: ['MobX', 'MobX-State-Tree', 'MobX-Keystone', 'Redux Toolkit', 'Zustand', 'React Query', 'Apollo Client']
  },
  {
    category: 'Styling & Animation',
    items: ['CSS', 'Dripsy', 'Native Base', 'Material UI', 'Ant Design', 'Bootstrap', 'Styled Components', 'Storybook', 'Reanimated', 'Lottie']
  },
  {
    category: 'Backend & Data',
    items: ['Node.js', 'Express', 'NestJS', 'Fastify', 'GraphQL', 'REST API', 'Socket.io', 'PostgreSQL', 'MySQL', 'MongoDB', 'Firebase', 'AWS', 'Terraform']
  },
  {
    category: 'Integrations',
    items: ['Stripe', 'OneSignal', 'Push Notifications', 'Branch (deep linking)', 'Google & Apple Auth', 'Google Maps', 'Sentry', 'Firebase Crashlytics', 'Intercom', 'Zendesk', 'SendGrid']
  },
  {
    category: 'Testing & DevOps',
    items: ['Jest', 'React Native Testing Library', 'Git', 'GitHub Actions', 'GitLab CI', 'EAS Build / Submit / Update', 'Fastlane', 'App Store Connect', 'Google Play Console']
  },
  {
    category: 'Tools & Libraries',
    items: ['React Navigation', 'React Hook Form', 'Formik', 'Yup', 'Axios', 'i18next', 'date-fns', 'Luxon', 'Lodash', 'MMKV', 'Performance Profiling', 'Figma', 'Postman']
  }
];

export default resumeSkills;
